import React, { Component } from "react";
import Section from "../components/Section";

class Features extends Component {
  render() {
    const features = [
      {
        key: "creation",
        title: "Développer votre présence web avec les outils de Google",
        text:
          "Créez vos sites extranet, intranet, portail clients en ligne, en utilisant Google Sites. Ajoutez des fonctionnalités avec Apps Script et App Maker."
      },
      {
        key: "gmail",
        title: "Une messagerie réputée et sécuritaire",
        text:
          "Utilisez la messagerie Gmail dans le cadre professionnel et bénéficiez d'une protection antispam, d'un moteur de recherche très performant et d'agendas conçus pour le travail en équipe."
      },
      {
        key: "dispo",
        title: "Vos données et applications disponibles en tout temps",
        text:
          "G Suite vous assure la garantie de disponibilité de vos données et applications en ligne à 99,9%, et vous propose un espace de stockage sécuritaire de 30 Gig (au minimum) avec Google Drive."
      },
      {
        key: "hangout",
        title: "Améliorer les communications au sein de votre organisation",
        text:
          "Organisez des réunions, des présentations via flux vidéo, et discutez (chattez) avec plusieurs interlocuteurs grâce à Google Hangouts."
      },
      {
        key: "applications",
        title: "Une multitude d'applications pour réaliser vos projets",
        text:
          "Utilisez les applications avancées Google Docs, Google Sheets, Google Slides, Google Forms pour travailler efficacement en ayant la possibilité de collaborer simultanément à plusieurs sur les mêmes documents."
      },
      {
        key: "drive",
        title: "Tout l'espace de stockage nécessaire dans un environnement sécuritaire",
        text:
          "Stockez vos fichiers et documents sur Google Drive pour les synchroniser et les partager en toute simplicité. Bénéficiez d'une console d'administration flexible pour gérer les droits d'accès et la sécurité."
      },

    ];
    const featureStyle = {
      margin: "20px",
      padding: "20px",
      backgroundColor: "#eef2f7",
      
    };
    const hrStyle = {
        width: "50px",
        borderTop: "5px solid rgb(228, 147, 6)",
        marginLeft: "0",
        marginBottom: "1rem"
    }

    // important - do not forget keys!
    const featuresList = features.map(feature => (
      <div className="col-md-6" key={feature.key}>
        <div style={featureStyle}>
          <h3 className="">{feature.title}</h3>
          <hr style={hrStyle}/>
          <p>{feature.text}</p>
        </div>
      </div>
    ));

    return (
      <Section>
        <div className="container" id="features">
        <div className="row">{featuresList}</div>
        </div>
      </Section>
    );
  }
}

export default Features;
